import { apiGet, apiPost } from "../../shared/api";

export type StatoPratica = "manca_nostro" | "aperta" | "rimborsata" | "respinta" | "chiusa";
export type TipoPratica = "danno" | "smarrimento" | "firma" | "servizio" | "altro";

/** Una pratica di rimborso con Bracchi, ricalcolata ogni ora dalle mail. */
export type Pratica = {
  id: number;
  ldv: string;
  tipo: TipoPratica;
  stato: StatoPratica;
  aperta_il: string;
  ultimo_il: string;
  ultimo_da_noi: boolean;
  ultimo_testo: string;
  /** La domanda di Bracchi, solo quando tocca a noi. */
  cosa_manca: string;
  /** La frase di Bracchi che ha deciso l'esito. */
  esito: string;
  /** Stringa: arriva da Decimal. */
  importo_rimborso: string | null;
  messaggi: number;
  cliente: string;
  ordine: { id: number; reference: string; canale: string } | null;
  abbinamento: "ldv" | "riferimento" | "nome" | null;
};

export type Reclami = {
  pratiche: Pratica[];
  conteggi: Record<StatoPratica, number>;
  attive: number;
  rimborsato: string;
  aggiornate_il: string | null;
  aggiornamento_in_corso: boolean;
};

const ROTTA = "/api/reclami";

export function fetchReclami(signal?: AbortSignal): Promise<Reclami> {
  return apiGet(ROTTA, signal ? { signal } : undefined);
}

export function rileggiReclami(): Promise<{ accodato: boolean }> {
  return apiPost(`${ROTTA}/rileggi`);
}
